import { Container } from 'src/components/common/Container'
import { css } from 'styled-components'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_m16, Noto_body2_r14 } from 'src/styles/fonts/NotoSansKrFonts'

type RefundInfoConfirmModalType = {
  text: string
  value: string
}

const RefundInfoConfirmModal = ({
  InformationEnteredList,
}: {
  InformationEnteredList: RefundInfoConfirmModalType[]
}) => {
  return (
    <Container $option="flex_column" $row_gap={'10px'}>
      <Container $option="flex_column" $row_gap="10px" $style={S.RefundInfoConfirmModalContainer}>
        {InformationEnteredList?.map(({ text, value }: RefundInfoConfirmModalType) => (
          <Container
            key={text}
            $option="flex_row_space_between"
            $style={S.RefundInfoConfirmModalContents}
          >
            <Typography $fontStyle={Noto_body1_m16}>{text}</Typography>
            <Typography $fontStyle={Noto_body2_r14}>{value}</Typography>
          </Container>
        ))}
      </Container>
      <Typography $fontStyle={Noto_body2_r14} $color={'var(--red-50)'} $margin="0 0 10px 0">
        제출 이후 수정이 어렵습니다. <br /> 제출을 원하시면 확인 버튼을 선택하세요.
      </Typography>
    </Container>
  )
}
export default RefundInfoConfirmModal

const S = {
  RefundInfoConfirmModalContainer: css`
    border: 1px solid var(--black-10);
    border-radius: 10px;
    padding: 10px;
  `,
  RefundInfoConfirmModalContents: css`
    align-items: flex-start;
    white-space: pre-line;
    text-align: right;
  `,
}
